<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <h1>Изменение цен по графику</h1>
    </v-col>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col cols="3" class="search-col">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="9" class="text-right" >
          <v-btn @click="$router.push({ name: 'change-price-create' })">Создать график</v-btn>
        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Нет данных"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :items="items"
          :server-items-length="total"
          :items-per-page="30"
          :options.sync="options"
          :fixed-header="true"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          height="60vh"
          :footer-props="footerProps"
          :loading="loading"
          loading-text="Загрузка... Подождите пожалуйста"
      >
        <template v-slot:item.products="{ item }">
          {{ item.products.map((val) => { return val.name}).join(', ') }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'change-price-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <v-dialog
          v-model="submitDialog"
          max-width="444"
      >
        <v-card>
          <v-card-title >
            Подтвердить действие
          </v-card-title>

          <v-card-actions>


            <v-btn
                v-if="submitItem == null"
                @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                v-else
                @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                outlined
                @click="submitDialog = false"
            >
              Нет
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import ChangePriceService from "@/api/ChangePriceService";

export default {
  name: 'ChangePriceIndex',
  components: {},
  data: () => ({
    loading: true,
    total: 0,
    selected: [],
    streets: [],
    submitDialog: false,
    submitItem: null,
    search: '',
    options: {},
    items: [],
    footerProps: {
      itemsPerPageText: 'Элементов на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [30]
    },
    headers: [
      {
        text: 'Дата создания',
        value: 'created_at',
        sortable: false,
      },
      {
        text: 'Дата изменения',
        value: 'change_at',
        sortable: false,
      },
      {
        text: 'Товары',
        value: 'products',
        sortable: false,
      },
      {
        text: 'Цена',
        value: 'price',
        sortable: false,
      },
      {
        text: 'Статус',
        value: 'status',
        sortable: false,
      },
      {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
    ],
  }),
  mounted() {
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search() {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.getDataFromApi()
      }, 700)
    }
  },
  methods: {
    submitDelete(item = null){
      if(item){
        this.remove(item)
      } else {
        //this.massDelete()
      }
    },
    remove(item){
      ChangePriceService.remove(item.id).then(response => {
        this.loading = true
        this.getDataFromApi()
      })
    },
    getDataFromApi() {
      this.loading = true
      this.selected = [];
      let params = {
        search: this.search
      }

      ChangePriceService.list(params)
          .then(response => {
            this.items = response.data.data
            this.total = response.data.total
            this.loading = false
          })
    },
  }
}
</script>

<style>
.changed-row{
  background-color: #FFEEEC;
}
</style>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}
span.v-btn{
  border-color: currentColor!important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }



  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
